import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert";
import { handleErrorFetchingData } from "../../../../functions/errorHandling";

export default function DeleteTrainingModal({ training, getTrainings, getTrainingMetadata }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = () => {
    swal({
      text: `Deleting ${training.name}... Please stand by.`,
      icon: require("../../../../static/images/spinner.gif"),
      button: false,
    });
    axios
      .patch(training.url, { is_active: false }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((response) => {
        swal({
          title: "Deleted",
          text: `${training.name} has been successfully deleted.`,
          icon: "success",
          button: "OK",
        });
        getTrainings(); // Refresh the list of trainings
        getTrainingMetadata(); // Refresh the list of training numbers and versions
        handleClose();
      })
      .catch((error) => {
        handleErrorFetchingData(error);
        handleClose();
      });
  };

  return (
    <React.Fragment>
      <Button variant="danger" onClick={handleShow}>
        Delete Training
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Training</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the training: <strong>{training.name}</strong>? This action can be undone by restoring it later.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/DeleteTrainingModal.js